import { BrowserRouter, Route, Routes } from 'react-router-dom'
import {
  CreateEventPage,
  DraftEventPage,
  EditEventPage,
  EventsPage,
  FAQPage,
  LiveEventPage,
  LoginPage,
  ManageEventsPage,
  NotFoundPage,
  PastUserEventsPage,
  CreatePollPage,
  EditPollPage,
  AnalyticsPage
} from '../../pages'
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute'

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <EventsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage"
          element={
            <ProtectedRoute>
              <ManageEventsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/faq"
          element={
            <ProtectedRoute>
              <FAQPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit/:id"
          element={
            <ProtectedRoute showLiveEventIndicator={false}>
              <EditEventPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/draft/:id"
          element={
            <ProtectedRoute showLiveEventIndicator={false}>
              <DraftEventPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create"
          element={
            <ProtectedRoute showLiveEventIndicator={false}>
              <CreateEventPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/live/:id"
          element={
            <ProtectedRoute showLiveEventIndicator={false}>
              <LiveEventPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/past"
          element={
            <ProtectedRoute>
              <PastUserEventsPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
        <Route
          path="/createpoll"
          element={
            <ProtectedRoute>
              <CreatePollPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/editpoll"
          element={
            <ProtectedRoute>
              <EditPollPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <AnalyticsPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
